import { render, staticRenderFns } from "./RateCourse.vue?vue&type=template&id=37d02a79"
import script from "./RateCourse.js?vue&type=script&lang=js&external"
export * from "./RateCourse.js?vue&type=script&lang=js&external"
import style0 from "./RateCourse.vue?vue&type=style&index=0&id=37d02a79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports